import script from "./TicketDetailItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./TicketDetailItem.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__